<template>
  <div>
    <vxe-grid
      size="small"
      row-id="colorCode"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="v_tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:deviceStatus="{ row }">
        <el-tag size="small" :type="row.isOffline ? 'danger' : 'primary'">
          {{ row.isOfflineText }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditDialog', {
                type: 'detail',
                deviceStatusCode: row.deviceStatusCode,
              })
            "
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { cloneDeep } from 'lodash'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      v_tableData: [],
    }
  },
  watch: {
    tableData: {
      handler() {
        this.v_tableData = []
        if (!this.tableData || this.tableData.length == 0) return
        this.v_tableData = cloneDeep(this.tableData)
        const nowTime = new Date()

        this.v_tableData.forEach((f) => {
          const bool =
            ((nowTime - new Date(f.statusTime)) / (1000 * 10) || 0) > 10
          f.isOfflineText = bool ? '离线' : '在线'
          f.isOffline = bool
        })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {},
}
</script>
